import { AddCircle } from '@mui/icons-material';
import { Button, IconButton } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import { createContext } from 'react';
import { AsuntoComponent } from '../../components/asuntos/AsuntoComponent';
import { ModalAgregaAsuntoComponent } from '../../components/asuntos/ModalAgregaAsuntoComponent';
import { ModalAgregaAvanceComponent } from '../../components/asuntos/ModalAgregaAvanceComponent';
import { ResumenAsuntoComponent } from '../../components/asuntos/ResumenAsuntoComponent';
import { TituloComponent } from '../../components/TituloComponent'
import { AuthContext } from '../../context/AuthContext';
import { ObtenerAsuntos } from '../../helpers/AsuntosHelper';

export const AsuntosContext = createContext();

export const AsuntosPage = () => {
    const {usuario} = useContext(AuthContext)
    const [asuntos, setAsuntos] = useState([]);
    const [asuntoSeleccionado, setAsuntoSeleccionado] = useState();
    const [tareaSeleccionada, setTareaSeleccionada] = useState();
    const [modalAgregaAsunto, setModalAgregaAsunto] = useState(false);
    const [modalAgregaAvance, setModalAgregaAvance] = useState(false);
    const [avanceSeleccionado, setAvanceSeleccionado] = useState();
    const [agregandoTarea, setAgregandoTarea] = useState(false);
    const [asuntosOriginal, setAsuntosOriginal] = useState();
    const [modalSeleccionInstalacion, setModalSeleccionInstalacion] = useState(false);
    const [instalacionSeleccionada, setInstalacionSeleccionada] = useState();
    const [asuntosMostrar, setAsuntosMostrar] = useState('misAsuntos')
    const [asuntosCompleto, setAsuntosCompleto] = useState();
    const obtenerAsuntos =() => {
        ObtenerAsuntos(usuario.IdUsuario).then(
            datos=> {
                let filtrados = new Array();
                if(asuntosMostrar=='misAsuntos') {
                    filtrados = datos?.filter(asunto => parseInt(asunto.IdResponsable) == usuario.IdUsuario )
                } else {
                    filtrados = datos?.filter(asunto => parseInt(asunto.IdUsuario) == usuario.IdUsuario )

                }
                
                setAsuntos(filtrados)
                setAsuntosCompleto(datos)
                setAsuntosOriginal(datos);
            });
      }   

      useEffect(() => {
        console.log('asuntos page', asuntos)
      }, [asuntos])

      useEffect(() => {
        console.log('cabio filtro', asuntosMostrar, asuntosCompleto)
        let filtrados = new Array();
        if(asuntosMostrar=='misAsuntos') {
            filtrados = asuntosCompleto?.filter(asunto => parseInt(asunto.IdResponsable) == usuario.IdUsuario )
        } else {
            filtrados = asuntosCompleto?.filter(asunto => parseInt(asunto.IdUsuario) == usuario.IdUsuario )

        }
        
        setAsuntos(filtrados)
}, [asuntosMostrar])
      

      useEffect(() => {
        obtenerAsuntos();
      }, []);
      
  return (
    <AsuntosContext.Provider value={{avanceSeleccionado, setAvanceSeleccionado, modalAgregaAvance, setModalAgregaAvance, instalacionSeleccionada, setInstalacionSeleccionada, modalSeleccionInstalacion, setModalSeleccionInstalacion,asuntoSeleccionado, setAsuntoSeleccionado, modalAgregaAsunto, setModalAgregaAsunto, obtenerAsuntos,
        agregandoTarea, setAgregandoTarea, tareaSeleccionada, setTareaSeleccionada
    }}>
    <div
        style={{
            display:'flex',
            flexDirection:'column',
            flex:1
        }}
    >
        <div
            style={{
                display:'flex',
                flexDirection:'row',
                flex:10,
                marginTop:10,
                marginLeft:40,
                marginRight:20,
            }}
        >
            <div
                style={{display:'flex',
                    flexDirection:'row',
                    flex:50,
                    justifyContent:'space-between',
                    backgroundColor:'transparent'
                }}
            >
                <TituloComponent titulo="Asuntos" />
                <div
                    style={{
                        display:'flex',
                        flexDirection:'row',
                        alignItems:'center'
                    }}
                >
                <Button
                    onClick={() =>{setAsuntosMostrar('misAsuntos')}}
                    variant='contained'
                    style={{
                        backgroundColor: asuntosMostrar=='misAsuntos' ? '#5F249F':'white',
                        color: asuntosMostrar=='misAsuntos' ? 'white':'black',
                        borderRadius:10,
                        textTransform:'unset'
                    }}
                >
                    Mis asuntos
                </Button>
                <Button
                    onClick={() =>{setAsuntosMostrar('asuntosAsigne')}}
                    variant='contained'
                    style={{
                        marginLeft:10,
                        backgroundColor: asuntosMostrar=='asuntosAsigne' ? '#5F249F':'white',
                        color: asuntosMostrar=='asuntosAsigne' ? 'white':'black',
                        borderRadius:10,
                        textTransform:'unset'
                        
                    }}
                >
                    Asuntos que asigné
                </Button>
                </div>
                <span
                    style={{
                        display:'flex',
                        marginRight:20
                    }}
                    >
                    <IconButton
                        onClick={() => {setModalAgregaAsunto(true)}}
                    >
                        <AddCircle style={{color:'#60318A'}} color="#60318A" />
                        Agregar
                    </IconButton>
                </span>

            </div>
            <div
                style={{display:'flex',
                    flexDirection:'row',
                    flex:50,
                }}
            >
                <TituloComponent titulo="" />
            </div>
        </div>
        <div
            style={{
                display:'flex',
                flexDirection:'row',
                flex:90,
                marginTop:10,
                marginLeft:40,
                marginRight:20,
                backgroundColor:'transparent',
                marginBottom:20,
                maxHeight:'50vw'
                
            }}
        >
            <div
                style={{display:'flex',
                    flexDirection:'row',
                    flex:50,
                }}
            >
                <div
                    style={{
                        display:'flex',
                        flexDirection:'column',
                        flex:1,
                        backgroundColor:'#f2f2f2',
                        padding:20,
                        marginRight:20,
                        borderRadius:10,
                        maxHeight:'80vh',
                        overflowX:'auto'
                    }}
                >
                    {
                        asuntos?.map(asunto => (
                            <AsuntoComponent  asunto={asunto} />
                        ))
                    }
                </div>
            </div>
            <div
                style={{display:'flex',
                    flexDirection:'row',
                    flex:50,
                }}
            >
                <div
                    style={{
                        display:'flex',
                        flexDirection:'column',
                        flex:1,
                        backgroundColor:'#f2f2f2',
                        padding:20,
                        borderRadius:10
                    }}
                >
                    <ResumenAsuntoComponent />
                </div>
            </div>
        </div>
    </div>
    <ModalAgregaAsuntoComponent />
    <ModalAgregaAvanceComponent />
    </AsuntosContext.Provider>
  )
}
